import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'gbc-loading-bar',
    templateUrl: './loading-bar.component.html',
    styleUrls: ['./loading-bar.component.scss'],
    standalone: true
})
export class LoadingBarComponent {
}
